import { createFileRoute } from "@tanstack/react-router";
import type * as React from "react";

import { ConsoleThemeProvider, EngineSignupPage } from "@/features/console";

export const Route = createFileRoute("/_authed/_modal/engine/get-started")({
  component: EngineGetStartedRoute,
});

function EngineGetStartedRoute(): React.ReactElement {
  return (
    <ConsoleThemeProvider>
      <EngineSignupPage />
    </ConsoleThemeProvider>
  );
}
